import { type CSSProperties, useMemo } from 'react';
import { MONTH_CELL_MIN_HEIGHT, MONTH_WEEKDAY_HEADER_HEIGHT } from '../../constants';

type Properties = {
  days: Date[];
};

export const useGetMonthViewStyle = ({ days }: Properties) => {
  const weekCount = days.length / 7;
  const monthViewStyle = useMemo(
    () =>
      ({
        minHeight: `${MONTH_WEEKDAY_HEADER_HEIGHT + weekCount * MONTH_CELL_MIN_HEIGHT}px`,
      }) satisfies CSSProperties,
    [weekCount],
  );
  const gridStyle = useMemo(
    () =>
      ({
        gridTemplateRows: `repeat(${weekCount}, minmax(${MONTH_CELL_MIN_HEIGHT}px, 1fr))`,
      }) satisfies CSSProperties,
    [weekCount],
  );

  return { gridStyle, monthViewStyle };
};
